export const isElementInView = (element?: Element): boolean => {
  if (!element) {
    return false;
  }
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.bottom <= window.innerHeight;
};
